import { BaseEntity } from './base-entity.model';

export abstract class ProjectEntity extends BaseEntity {
    project: {
        externalId: string
    };
}
